<template lang="pug">
.text-ellipsis
  .divider
  footer.text-dark(:class="{ collapsed: collapsed }")
    span
      | Desenvolvido por
      a(href='http://paliari.com.br' target='_blank') &nbsp;Paliari Engenharia de Software&nbsp;
      | © {{ new Date().getFullYear() }}&nbsp;
    code
      small (v{{version}})
</template>

<script>
import { version } from '../../../package'

export default {
  props: { collapsed: Boolean },
  data() {
    return {
      version,
    }
  },
}
</script>

<style lang="stylus" scoped>
footer
  text-align right
  padding 5px
  font-size .7rem
  a
    text-decoration none
</style>
